@if (trail().days.length === 0) {
  <p class="wat-empty">No events recorded yet.</p>
} @else {
  <ol class="wat-list" aria-label="Audit trail events">
    @for (day of trail().days; track day.dateUtc) {
      @for (lane of day.lanes; track lane.acts[0].id) {
        @for (act of lane.acts; track act.id) {
          <li class="wat-row" [class.wat-row--muted]="act.muted">
            <time class="wat-time" [attr.datetime]="act.atUtc">{{ act.atUtc | date: 'MMM d, HH:mm:ss' : '+0100' }} WAT</time>
            <span class="wat-who">
              <strong>{{ lane.actorName }}</strong>
              <span class="wat-role" [class.wat-role--system]="lane.isSystem">
                {{ lane.isSystem ? 'System' : roleLabel(lane.role) }}
              </span>
            </span>
            <span class="wat-what">
              <span class="wat-headline">{{ act.headline }}</span>
              @if (act.details.length > 0) {
                <span class="wat-detail">
                  @for (detail of act.details; track $index) {
                    @if (!$first) {
                      <span aria-hidden="true"> · </span>
                    }
                    <span>{{ detail.label }}: {{ detail.text }}</span>
                  }
                </span>
              }
            </span>
          </li>
          @for (line of act.automatic; track $index) {
            <li class="wat-row wat-row--auto">
              <time class="wat-time" [attr.datetime]="act.atUtc">{{ act.atUtc | date: 'MMM d, HH:mm:ss' : '+0100' }} WAT</time>
              <span class="wat-auto-who">Workflow engine (automatic)</span>
              <span class="wat-what">
                <span class="wat-auto-line" role="group" aria-label="Done automatically by the workflow engine">{{ line }}</span>
              </span>
            </li>
          }
        }
      }
    }
  </ol>
}